import { render, staticRenderFns } from "./AdminAcademic.html?vue&type=template&id=37e3900c&scoped=true&external"
import script from "./AdminAcademic.vue?vue&type=script&lang=js"
export * from "./AdminAcademic.vue?vue&type=script&lang=js"
import style0 from "./AdminAcademic.scss?vue&type=style&index=0&id=37e3900c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e3900c",
  null
  
)

export default component.exports